const DISPLAY_NAME_OVERRIDES: Record<string, string> = {
  VAS: 'Value-Added Services',
  'Marketplace Integrations': 'Integration hub',
};

export function getDisplayName(name: string): string {
  return DISPLAY_NAME_OVERRIDES[name] ?? (name.startsWith('Shift4 ') ? name.slice(7) : name);
}

type ParentPlatformRule = {
  matches: (name: string) => boolean;
  result: { platform: string; tab: string };
};

const parentPlatformRules: ParentPlatformRule[] = [
  {
    matches: name => name.includes('marketplace integrations') || name.includes('skytab marketplace'),
    result: { platform: 'Shift4 Dine', tab: 'level2-marketplace-integrations' },
  },
  {
    matches: name => name.includes('shift4 venue') || name.includes('skytab venue'),
    result: { platform: 'Shift4 Venue', tab: 'product-modules' },
  },
];

export function mapToParentPlatform(platformName: string): { platform: string; tab: string } {
  const name = platformName.toLowerCase();
  return (
    parentPlatformRules.find(rule => rule.matches(name))?.result ?? {
      platform: platformName,
      tab: 'product-modules',
    }
  );
}
